import { type ReactElement } from 'react';
import { IconDialogAlert } from '@direct-frontend/components';
import { type SchemaDigitalOrder } from '@/shared/api/openApi';
import IconSuccess from '@/shared/assets/IconSuccess.react.svg';

export const getDigitalCheckoutFeedbackIcon = (order: SchemaDigitalOrder): ReactElement => {
    if (order.status === 'CANCELLED') {
        return <IconDialogAlert size="64" />;
    }

    return <IconSuccess width="52" />;
};
